import { ComponentMeta, ComponentStory } from "@storybook/react";
import { AlignJustify } from "lucide-react";
import React from "react";
import { MemoryRouter } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Page from "../Page/Page";

const commonArgs: React.ComponentProps<typeof Page> = {
    title: "Page Title",
    topBarHeight: "5em",
    stretch: false,
    padding: "2em"
};

export default {
    title: "Layout/Page",
    component: Page,
    args: commonArgs
} as ComponentMeta<typeof Page>;

const Template: ComponentStory<typeof Page> = ({ ...args }) => {
    return (
        <MemoryRouter initialEntries={["/"]}>
            <Page {...args}>
                <p>Page Content</p>
            </Page>
        </MemoryRouter>
    );
};

export const Default = Template.bind({});

export const WithTopBar = Template.bind({});
WithTopBar.args = {
    topBar: {
        sidebarButton: <AlignJustify />,
        tabs: [
            {
                title: "Tab A",
                path: "/"
            },
            {
                title: "Tab B",
                path: "/b"
            }
        ],
        backlink: {
            title: "Back to all",
            url: "/",
            trackName: "trackName"
        },
        breadcrumbs: (
            <Breadcrumbs
                breadcrumbs={[
                    {
                        title: "Page A",
                        to: "/page"
                    },
                    {
                        title: "Page B",
                        isBeta: true
                    }
                ]}
            />
        )
    }
};
